import axios from 'axios';
import { API_ENDPOINTS, API_HEADERS, API_METHODS } from './constants';

// API URL'leri
const API_URL = API_ENDPOINTS.WEBSERVICE;

// Axios instance oluştur
const api = axios.create({
  baseURL: API_URL,
  headers: API_HEADERS
});

// Response interceptor ekle
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.data?.message === 'Oturum bilgileri eksik veya geçersiz.') {
      // Token geçersiz ise kullanıcıyı çıkış yaptır
      localStorage.removeItem('userInfo');
      sessionStorage.removeItem('userInfo');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Yanıt tipleri
interface CheckUserResponse {
  success: boolean;
  message: string;
  token?: string;
  data?: {
    uyeid: string;
    uyeno: string;
    kimlikno: string;
    grubu: string;
    durumu: string;
    token: string;
  };
}

interface SmsVerifyResponse {
  success: boolean;
  message: string;
  smsid?: string;
  sms_code?: string;
  uyeid?: string;
  uyeno?: string;
  kimlikno?: string;
  grubu?: string;
  data?: {
    token: string;
    user: {
      uyeid: string;
      uyeno: string;
      kimlikno: string;
      grubu: string;
      durumu: string;
    };
  };
}

export interface Borc {
  COUNTER: number;
  TARIH: string;
  ACIKLAMA: string;
  BORC: number;
  ALACAK: number;
  uyeid: string;
  NETBORC?: number;
  selected?: boolean; // UI için gerekli
}

export interface BorcDetay {
  borc_id: string;
  borc_tarihi: string;
  borc_tutari: number;
  borc_aciklamasi: string;
  odeme_durumu: string;
}

export interface Odeme {
  COUNTER: number;
  TARIH: string;
  ACIKLAMA: string;
  BORC: number;
  ALACAK: number;
  uyeid: number;
  odemetarih: string | null;
  islem: string;
}

export interface Kullanici {
  uyeid: string;
  uyeno: string;
  kimlikno?: string;
  grubu: string;
  durumu: string;
  ADI: string;
  SOYADI: string;
  KARTRESIM: string;
  toplam_borc?: number;
  borc_detay?: BorcDetay[];
  // Tahsilatlar için
  odemeler?: Odeme[];
  toplam_odeme?: number;
  borc?: number;
  alacak?: number;
}

interface BorcResponse {
  success: boolean;
  message: string;
  data?: {
    borclar: Array<{
      uyeid: string;
      uyeno: string;
      kimlikno: string;
      grubu: string;
      durumu: string;
      ADI: string;
      SOYADI: string;
      KARTRESIM: string;
      toplam_borc: number;
      borc_detay: Array<{
        borc_id: string;
        borc_tarihi: string;
        borc_tutari: number;
        borc_aciklamasi: string;
        odeme_durumu: string;
      }>;
    }>;
  };
}

export interface BaseResponse {
  success: boolean;
  message: string;
  data?: any;
}

export interface OdemeResponse extends BaseResponse {
  data?: {
    odemeId: string;
    durum: string;
    tarih: string;
    tutar: string;
  };
}

export interface SepetItem {
  COUNTER: number;
  TARIH: string;
  ACIKLAMA: string;
  BORC: number;
  ALACAK: number;
  uyeid: string;
  NETBORC: number;
}

interface SepetResponse {
  success: boolean;
  message?: string;
  data: {
    sepet: SepetItem[];
  };
}

export interface Tahsilat {
      tahsilat_id: string;
      tahsilat_tarihi: string;
      tahsilat_tutari: number;
      tahsilat_turu: string;
      aciklama: string;
  kullanici_adi: string;
  kullanici_grubu: string;
  odeme_durumu: string;
  odeme_tipi: string;
}

export interface TahsilatResponse {
  success: boolean;
  message: string;
  data?: {
    kullanicilar?: Kullanici[];
    borclar?: Kullanici[];
    tahsilatlar?: Tahsilat[];
  };
}

/**
 * TC Kimlik ve Telefon ile kullanıcı kontrolü yapar
 * @param tcKimlik TC Kimlik Numarası
 * @param telefon Cep Telefonu
 * @returns Kontrol yanıtı
 */
export const checkUser = async (tcKimlik: string, telefon: string): Promise<CheckUserResponse> => {
  try {
    console.log('CheckUser API isteği:', { tcKimlik, telefon });
    const response = await api.post('', {
      method: API_METHODS.CHECK_USER,
      kimlikno: tcKimlik,
      ceptel: telefon
    });
    
    console.log('CheckUser API yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('Kullanıcı kontrolü hatası:', error);
    console.error('Hata detayı:', error.response?.data || error.message);
    
    return {
      success: false,
      message: error.response?.data?.message || 
              error.message || 
              'Kullanıcı kontrolü sırasında bir hata oluştu.'
    };
  }
};

/**
 * SMS doğrulama kodunu kontrol eder
 * @param token Kimlik doğrulama token'ı
 * @param smscode SMS kodu
 * @returns Doğrulama yanıtı
 */
export const verifySmsCode = async (tcKimlik: string, telefon: string, smsCode: string): Promise<SmsVerifyResponse> => {
  try {
    console.log('VerifySmsCode API isteği:', { tcKimlik, telefon, smsCode });
    const token = localStorage.getItem('payment_token') || sessionStorage.getItem('payment_token') || '';
    console.log('Token:', token);
    
    const response = await api.post(
      '',
      {
        method: 'apibilgileri',
        Sayfa: 'apibilgileri',
        smscode: smsCode,
        token: token
      }
    );
    
    console.log('VerifySmsCode API yanıtı:', response.data);
    const result: SmsVerifyResponse = {
      ...response.data
    };
    return result;
  } catch (error: any) {
    console.error('SMS doğrulama hatası:', error);
    console.error('Hata detayı:', error.response?.data || error.message);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'SMS doğrulama sırasında bir hata oluştu.'
    };
  }
};

/**
 * Kullanıcının borçlarını getirir
 * @returns Borç listesi yanıtı
 */
export const getBorclar = async (uyeId: string, uyeno: string, kimlikno: string, grubu: string): Promise<BorcResponse> => {
  try {
    console.log('GetBorclar API isteği:', { uyeId, uyeno, kimlikno, grubu });
    const response = await api.post('', {
      method: API_METHODS.GET_BORCLAR,
      uyeId,
      uyeno,
      kimlikno,
      grubu
    });
    console.log('GetBorclar API yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('Borç listesi getirme hatası:', error);
    console.error('Hata detayı:', error.response?.data || error.message);
    return {
      success: false,
      message: error.response?.data?.message || 
              error.message || 
              'Borç listesi alınırken bir hata oluştu.'
    };
  }
};

/**
 * Ödeme işlemini gerçekleştirir
 * @param uyeId Kullanıcı ID
 * @param borcId Borç ID
 * @param tutar Ödeme tutarı
 * @returns Ödeme yanıtı
 */
export const odemeYap = async (uyeId: string, borcId: string, tutar: number): Promise<OdemeResponse> => {
  try {
    const response = await api.post('/borc/odemeYap', {
      uyeId,
      borcId,
      tutar
    });
    return response.data;
  } catch (error) {
    console.error('Ödeme hatası:', error);
    return {
      success: false,
      message: 'Ödeme işlemi sırasında bir hata oluştu.'
    };
  }
};

export const getSepet = async (SepetId?: string): Promise<SepetResponse> => {
  try {
    const response = await api.post('getSepet', {
      ...(SepetId && { SepetId })
    });
    return response.data;
  } catch (error) {
    console.error('Sepet bilgileri getirme hatası:', error);
    throw error;
  }
};

export const addToSepet = async (item: SepetItem): Promise<SepetResponse> => {
  try {
    const sepetJson = localStorage.getItem('sepet');
    const sepet = sepetJson ? JSON.parse(sepetJson) : [];
    
    // Aynı borç daha önce eklenmiş mi kontrol et
    const existingItem = sepet.find((i: SepetItem) => i.COUNTER === item.COUNTER);
    if (!existingItem) {
      sepet.push(item);
      localStorage.setItem('sepet', JSON.stringify(sepet));
    }
    
    return {
      success: true,
      data: {
        sepet
      }
    };
  } catch (error) {
    console.error('Sepete ekleme hatası:', error);
    return {
      success: false,
      message: 'Ürün sepete eklenirken bir hata oluştu.',
      data: { sepet: [] }
    };
  }
};

export const removeFromSepet = async (itemId: number): Promise<SepetResponse> => {
  try {
    const sepetJson = localStorage.getItem('sepet');
    let sepet = sepetJson ? JSON.parse(sepetJson) : [];
    
    sepet = sepet.filter((item: SepetItem) => item.COUNTER !== itemId);
    localStorage.setItem('sepet', JSON.stringify(sepet));
    
    return {
      success: true,
      data: {
        sepet
      }
    };
  } catch (error) {
    console.error('Sepetten çıkarma hatası:', error);
    return {
      success: false,
      message: 'Ürün sepetten çıkarılırken bir hata oluştu.',
      data: { sepet: [] }
    };
  }
};

/**
 * Tahsilat listesi
 * @param uyeId Kullanıcı ID
 * @returns Tahsilat listesi yanıtı
 */
export const getTahsilatlar = async (uyeId: string): Promise<TahsilatResponse> => {
  try {
    const response = await api.post('', {
      method: API_METHODS.GET_TAHSILATLAR,
      uyeId
    });

    return response.data;
  } catch (error: any) {
    console.error('Tahsilatlar alınırken hata:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Tahsilatlar alınamadı'
    };
  }
};

export const makePayment = async (paymentData: {
  uyeId: string;
  borcId: string;
  odenenTutar: string;
  odemeSekli: string;
}): Promise<OdemeResponse> => {
  try {
    console.log('makePayment API isteği:', { ...paymentData });
    const response = await api.post('odemeYap', {
      ...paymentData
    });

    console.log('makePayment API yanıtı:', response.data);
    return {
      success: response.data.success || false,
      message: response.data.message || 'İşlem sırasında bir hata oluştu',
      data: response.data.data
    };
  } catch (error: any) {
    console.error('Ödeme işlemi sırasında hata:', error);
    console.error('Hata detayı:', error.response?.data || error.message);
    return {
      success: false,
      message: error.response?.data?.message || 
               error.message || 
               'Ödeme işlemi sırasında beklenmeyen bir hata oluştu'
    };
  }
};

// Sepet oluşturma
export const createSepet = async (borcid: string, amount: number, description: string, uyeid: string, uye: string, SepetId: string) => {
  try {
    const response = await api.post('createSepet', {
      borcid,
      amount,
      description,
      uyeid,
      uye,
      SepetId
    });
    return response.data;
  } catch (error) {
    console.error('Sepet oluşturma hatası:', error);
    throw error;
  }
};

// Sepetten ürün kaldırma
export const removeSepet = async (borcid: string, SepetId: string) => {
  try {
    const response = await api.post('removeSepet', {
      borcid,
      SepetId
    });
    return response.data;
  } catch (error) {
    console.error('Sepetten ürün kaldırma hatası:', error);
    throw error;
  }
};

// Ödeme işlemi
export const processPayment = async (
  sepetId: string,
  cardName: string,
  cardNumber: string,
  cardExpiry: string,
  cardCvv: string,
  amount: number
) => {
  try {
    const response = await api.post('processPayment', {
      sepetId,
      cardName,
      cardNumber,
      cardExpiry,
      cardCvv,
      amount
    });
    return response.data;
  } catch (error) {
    console.error('Ödeme işlemi hatası:', error);
    throw error;
  }
};

// Ödeme onaylama
export const confirmPayment = async (
  sepetId: string,
  transId?: string,
  authCode?: string,
  cardIssuer?: string
) => {
  try {
    const response = await api.post('confirmPayment', {
      sepetId,
      transId,
      authCode,
      cardIssuer
    });
    return response.data;
  } catch (error) {
    console.error('Ödeme onaylama hatası:', error);
    throw error;
  }
};

// Tahsilat detayı getirme
export const getTahsilatDetay = async (tahsilatId: string) => {
  try {
    const response = await api.post('getTahsilatDetay', {
      tahsilatId
    });
    return response.data;
  } catch (error) {
    console.error('Tahsilat detayı getirme hatası:', error);
    throw error;
  }
};

// İstek/Şikayet gönderme
export const sendIstekSikayet = async (
  uyeid: string,
  adSoyad: string,
  konu: string,
  tip: 'ISTEK' | 'SIKAYET',
  aciklama: string,
  iletisimTercihi?: string
) => {
  try {
    const response = await api.post('sendIstekSikayet', {
      uyeid,
      adSoyad,
      konu,
      tip,
      aciklama,
      iletisimTercihi
    });
    return response.data;
  } catch (error) {
    console.error('İstek/Şikayet gönderme hatası:', error);
    throw error;
  }
};

// Kullanıcı bilgilerini kaydet
export const saveUserInfo = (userInfo: any, rememberMe: boolean = true) => {
  const userData = {
    ...userInfo,
    timestamp: Date.now(),
    expiresAt: Date.now() + (rememberMe ? 30 * 24 * 60 * 60 * 1000 : 24 * 60 * 60 * 1000) // 30 gün veya 1 gün
  };
  
  if (rememberMe) {
    localStorage.setItem('userInfo', JSON.stringify(userData));
    localStorage.setItem('rememberMe', 'true');
  }
  sessionStorage.setItem('userInfo', JSON.stringify(userData));
};

// Kullanıcı bilgilerini al
export const getUserInfo = () => {
  // Önce sessionStorage'dan kontrol et
  let userInfo = sessionStorage.getItem('userInfo');
  
  if (!userInfo) {
    // SessionStorage'da yoksa localStorage'dan al
    userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      const userData = JSON.parse(userInfo);
      // Süre kontrolü
      if (userData.expiresAt && Date.now() > userData.expiresAt) {
        // Süresi dolmuş, temizle
        clearUserInfo();
        return null;
      }
      // SessionStorage'a da kopyala
      sessionStorage.setItem('userInfo', userInfo);
    }
  }
  
  if (userInfo) {
    const userData = JSON.parse(userInfo);
    // Süre kontrolü
    if (userData.expiresAt && Date.now() > userData.expiresAt) {
      clearUserInfo();
      return null;
    }
    return userData;
  }
  
  return null;
};

// Kullanıcı bilgilerini temizle
export const clearUserInfo = () => {
  localStorage.removeItem('userInfo');
  localStorage.removeItem('rememberMe');
  sessionStorage.removeItem('userInfo');
  sessionStorage.removeItem('uyeId');
  sessionStorage.removeItem('uyeno');
  sessionStorage.removeItem('kimlikno');
  sessionStorage.removeItem('grubu');
  sessionStorage.removeItem('adSoyad');
};

// Login durumunu kontrol et - SMS doğrulaması tamamlanmış kullanıcılar için
export const isLoggedIn = (): boolean => {
  const userInfo = getUserInfo();
  
  const hasUserInfo = userInfo !== null;
  const hasUyeid = userInfo && userInfo.uyeid;
  // uyeid hem string hem number olabilir, sadece var mı kontrol edelim
  const uyeidValid = hasUyeid && (
    (typeof userInfo.uyeid === 'string' && userInfo.uyeid.length > 0) ||
    (typeof userInfo.uyeid === 'number' && userInfo.uyeid > 0)
  );
  
  return hasUserInfo && uyeidValid;
};

// Token'ı yenile
export const refreshUserSession = () => {
  const userInfo = getUserInfo();
  if (userInfo) {
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    saveUserInfo(userInfo, rememberMe);
  }
};

// Yakıt hareketleri interface'leri
export interface YakitHareket {
  Id: number;
  Plate: string;
  Pompa_No: number;
  Urun_Adi: string;
  Satis_Tarihi: string;
  Litre: number;
  Tutar: number;
  Odeme_Tipi: string;
}

export interface YakitHareketleriResponse {
  success: boolean;
  message: string;
  data?: {
    hareketler: YakitHareket[];
    ozet: {
      toplam_litre: number;
      toplam_tutar: number;
      hareket_sayisi: number;
      period: string;
    };
  };
}

// Plaka geçişleri interface'leri
export interface PlakaGecis {
  Id: number;
  Plate: string;
  Date: string;
  Machine: string;
  Color: string;
  grup: number;
  sirano: number;
  groupkey: string;
  uye: number;
  yon: number;
  tip: 'GIRIS' | 'CIKIS';
}

export interface PlakaGecisleriResponse {
  success: boolean;
  message: string;
  data?: {
    gecisler: PlakaGecis[];
    ozet: {
      giris_sayisi: number;
      cikis_sayisi: number;
      toplam_gecis: number;
      period: string;
    };
  };
}

// Yakıt hareketlerini getir
export const getYakitHareketleri = async (plaka: string, period: 'gunluk' | 'haftalik' | 'aylik' = 'gunluk'): Promise<YakitHareketleriResponse> => {
  try {
    const response = await api.post('', {
      method: API_METHODS.GET_YAKIT_HAREKETLERI,
      plaka,
      period
    });
    return response.data;
  } catch (error) {
    console.error('Yakıt hareketleri getirme hatası:', error);
    throw error;
  }
};

// Plaka geçişlerini getir
export const getPlakaGecisleri = async (plaka: string, period: 'gunluk' | 'haftalik' | 'aylik' = 'gunluk'): Promise<PlakaGecisleriResponse> => {
  try {
    const response = await api.post('', {
      method: API_METHODS.GET_PLAKA_GECISLERI,
      plaka,
      period
    });
    return response.data;
  } catch (error) {
    console.error('Plaka geçişleri getirme hatası:', error);
    throw error;
  }
}; 